<template>

  <t-dialog
      v-model:visible="visible"
      header="添加用户"
      width="500"
      @confirm="submit"
  >

    <t-form :data="form">

      <t-form-item label="用户名称">
        <t-input v-model="form.user_name"/>
      </t-form-item>

      <t-form-item label="手机号">
        <t-input v-model="form.phone"/>
      </t-form-item>

      <t-form-item label="密码">
        <t-input v-model="form.password" type="password"/>
      </t-form-item>

    </t-form>

  </t-dialog>

</template>

<script setup>

import { ref,watch } from 'vue'
import { addUserApi } from '@/api/user'
import {DialogPlugin, MessagePlugin} from 'tdesign-vue-next'
import md5 from "md5";

const props=defineProps({
  visible:Boolean
})

const emit=defineEmits(['update:visible','success'])

const visible=ref(false)



watch(visible,(v)=>{
  emit('update:visible',v)
})

const form=ref({
  user_name:'',
  phone:'',
  password:''
})

watch(()=>props.visible,(v)=>{
  if (v) {
    form.value.password = generateSecureCode(12)
  }
  visible.value=v
})

const submit=()=>{

  let param = {
    user_name : form.value.user_name,
    phone:  form.value.phone,
    password: md5(form.value.password)
  }
  addUserApi(param).then(res=>{
    if (res.data.code == 200) {
      MessagePlugin.success("添加成功")
      visible.value=false

      // 弹框提示账号密码
      const dialog = DialogPlugin.alert({
        header: '用户创建成功',
        body: `手机号：${form.value.phone}   密码：${form.value.password}`,
        confirmBtn: '我知道了',
        onConfirm: () => {
          dialog.hide()
        }
      })

      emit('success')
    } else {
      MessagePlugin.warning(res.data.msg)
    }

  })

}

function generateSecureCode(length = 8) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const array = new Uint32Array(length)
  window.crypto.getRandomValues(array)

  return Array.from(array)
      .map(x => chars[x % chars.length])
      .join('')
}

</script>